import React from 'react'
import * as S from './styles'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const DateHeader = ({ title, subtitle, loading }) => {
  return (
    <>
      {loading ? <S.SkeletonContainer>
        <Skeleton width='190px' height='16px' />
        <Skeleton width='290px' height='16px' />
      </S.SkeletonContainer> : <>
        {title && <S.Title>{title}</S.Title>}
        {subtitle && <S.Subtitle>{subtitle}</S.Subtitle>}
      </>}
    </>
  )
}

export default DateHeader
